"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionParser = void 0;
const appendAttributePath_js_1 = require("../../../schema/actions/utils/appendAttributePath.js");
const index_js_1 = require("../../../schema/index.js");
const appendAttributeValue_js_1 = require("./appendAttributeValue.js");
const appendAttributeValueOrPath_js_1 = require("./appendAttributeValueOrPath.js");
const index_js_2 = require("./parseCondition/index.js");
const toCommandOptions_js_1 = require("./toCommandOptions.js");
class ConditionParser extends index_js_1.SchemaAction {
    constructor(schema, id = '') {
        super(schema);
        this.id = id;
        this.expressionAttributePrefix = `c${id}_`;
        this.expressionAttributeNames = [];
        this.expressionAttributeValues = [];
        this.expression = '';
    }
    setId(nextId) {
        this.id = nextId;
        this.expressionAttributePrefix = `c${nextId}_`;
        return this;
    }
    resetExpression(initialStr = '') {
        this.expression = initialStr;
        return this;
    }
    appendAttributePath(attributePath, options = {}) {
        return (0, appendAttributePath_js_1.appendAttributePath)(this, attributePath, options);
    }
    appendAttributeValue(attribute, expressionAttributeValue, options = {}) {
        (0, appendAttributeValue_js_1.appendAttributeValue)(this, attribute, expressionAttributeValue, options);
        return this;
    }
    appendAttributeValueOrPath(attribute, expressionAttributeValueOrPath, options = {}) {
        (0, appendAttributeValueOrPath_js_1.appendAttributeValueOrPath)(this, attribute, expressionAttributeValueOrPath, options);
        return this;
    }
    appendToExpression(conditionExpressionPart) {
        this.expression += conditionExpressionPart;
        return this;
    }
    parse(condition) {
        (0, index_js_2.parseCondition)(this, condition);
        return this;
    }
    toCommandOptions() {
        return (0, toCommandOptions_js_1.toCommandOptions)(this);
    }
    clone(schema) {
        const clonedParser = new ConditionParser(schema !== null && schema !== void 0 ? schema : this.schema, this.id);
        clonedParser.expressionAttributeNames = [...this.expressionAttributeNames];
        clonedParser.expressionAttributeValues = [...this.expressionAttributeValues];
        clonedParser.expression = this.expression;
        return clonedParser;
    }
}
exports.ConditionParser = ConditionParser;
